import * as React from "react";
import styled from "styled-components";
import { Input, Row, Col } from "components/bootstrap";
import { FormikInput } from "components/common";
const StyledUl = styled.ul`
  list-style-type: circle;
`;
export const PASSWORD_MIN_LENGTH = 16;
export const validateCloudPasswords = (errors, password, passwordRepeat) => {
  const newErrors = { ...errors };
  const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/;
  if (password && password.length < PASSWORD_MIN_LENGTH) {
    newErrors.password = `Password must be at least ${PASSWORD_MIN_LENGTH} characters long`;
  }
  if (!pattern.test(password)) {
    newErrors.password = "The password does not match the requirements below.";
  }
  if (password && passwordRepeat) {
    const passwordMatches = password === passwordRepeat;
    if (!passwordMatches) {
      newErrors.password_repeat = "Passwords do not match";
    }
  }
  return newErrors;
};
const CloudPasswordFormGroup = ({}) => {
  const passwordHelp = () => /* @__PURE__ */ React.createElement(React.Fragment, null, "Password requirements:", /* @__PURE__ */ React.createElement(StyledUl, null, /* @__PURE__ */ React.createElement("li", null, `Minimum length: ${PASSWORD_MIN_LENGTH} characters`), /* @__PURE__ */ React.createElement("li", null, "Contains at least one lower case letter"), /* @__PURE__ */ React.createElement("li", null, "Contains at least one upper case letter"), /* @__PURE__ */ React.createElement("li", null, "Contains at least one number (0-9)"), /* @__PURE__ */ React.createElement("li", null, "Does not contain part of your username")));
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "password-field",
      label: "Password",
      help: passwordHelp(),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(Row, { className: "no-bm" }, /* @__PURE__ */ React.createElement(Col, { sm: 6 }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        name: "password",
        id: "password",
        type: "password",
        placeholder: "Password",
        required: true,
        formGroupClassName: "form-group no-bm",
        wrapperClassName: "col-xs-12",
        minLength: PASSWORD_MIN_LENGTH
      }
    )), /* @__PURE__ */ React.createElement(Col, { sm: 6 }, /* @__PURE__ */ React.createElement(
      FormikInput,
      {
        name: "password_repeat",
        id: "password_repeat",
        type: "password",
        placeholder: "Repeat password",
        formGroupClassName: "form-group no-bm",
        required: true,
        wrapperClassName: "col-xs-12",
        minLength: PASSWORD_MIN_LENGTH
      }
    )))
  );
};
export default CloudPasswordFormGroup;
